/* Buffalo Barbecue Quest Fest, event page behavior. Vanilla, no dependencies.
   - Countdown line in the hero ([data-fest-countdown])
   - Add to calendar: builds a two-day .ics on click ([data-fest-ics])
   - Fundraising meter fills once when it scrolls into view ([data-animate="meter"]) */
(function () {
  var root = document.documentElement;
  root.classList.add('js-ready');

  function countdown() {
    var el = document.querySelector('[data-fest-countdown]');
    if (!el) return;
    var start = new Date(el.getAttribute('data-start'));
    var end = new Date(el.getAttribute('data-end'));
    var now = new Date();
    if (isNaN(start) || isNaN(end)) return;
    if (now > end) { el.textContent = ''; return; }
    if (now >= start) { el.textContent = 'Happening now'; return; }
    var days = Math.ceil((start - now) / 86400000);
    el.textContent = days === 1 ? 'Tomorrow' : days + ' days to go';
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function stamp(iso) {
    var d = new Date(iso);
    return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()) + 'T' +
      pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + '00Z';
  }

  function calendar() {
    document.querySelectorAll('[data-fest-ics]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var title = btn.getAttribute('data-title');
        var place = btn.getAttribute('data-location');
        var url = btn.getAttribute('data-url') || window.location.href;
        var desc = btn.getAttribute('data-description') || '';
        var days = JSON.parse(btn.getAttribute('data-days') || '[]');
        var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Buffalo Barbecue Quest//Fest//EN', 'CALSCALE:GREGORIAN'];
        days.forEach(function (day, i) {
          lines.push(
            'BEGIN:VEVENT',
            'UID:bbq-quest-fest-' + stamp(day.start) + '-' + i + '@buffalobarbecuequest.com',
            'DTSTAMP:' + stamp(new Date().toISOString()),
            'DTSTART:' + stamp(day.start),
            'DTEND:' + stamp(day.end),
            'SUMMARY:' + title,
            'LOCATION:' + place.replace(/,/g, '\\,'),
            'DESCRIPTION:' + (desc + ' ' + url).replace(/,/g, '\\,'),
            'URL:' + url,
            'END:VEVENT'
          );
        });
        lines.push('END:VCALENDAR');
        var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'buffalo-barbecue-quest-fest.ics';
        document.body.appendChild(a);
        a.click();
        window.setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
      });
    });
  }

  function meter() {
    var el = document.querySelector('[data-animate="meter"]');
    if (!el) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.setAttribute('data-visible', '');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        el.setAttribute('data-visible', '');
        io.disconnect();
      });
    }, { threshold: 0.5 });
    io.observe(el);
  }

  countdown();
  calendar();
  meter();
})();
